import { useLocation } from "react-router-dom";
import { tracRoutes } from "src/data/routes";
import { useAnalytics } from "src/hooks/analytics.hook";
import { previousAtom } from "src/store";
import { useAtom } from "jotai";

type InfoProps = {
  pages_total?: number;
  page_number?: number;
}
export function usePageTracking() {
  const { track } = useAnalytics();
  const [previous, setPrevious] = useAtom(previousAtom);
  const location = useLocation();
  
  const trackPage = (info?: InfoProps) => {    
    track("Page", {
      page_current: tracRoutes.find((route) =>
        location.pathname?.includes(route?.route)
      )?.page,
      page_previous: previous && tracRoutes.find((route) =>
        previous?.includes(route?.route)
      )?.page,
      ...info
    });
    setPrevious(location.pathname);
  }

  return { trackPage };
}